/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-investigation-list.reducer';

export const BloodBankInvestigationListDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankInvestigationListEntity = useAppSelector(state => state.bloodBankInvestigationList.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankInvestigationListDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.detail.title">BloodBankInvestigationList</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankInvestigationListEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.test">Test</Translate>
          </dt>
          <dd>{bloodBankInvestigationListEntity.test ? bloodBankInvestigationListEntity.test.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankInvestigationList.bank">Bank</Translate>
          </dt>
          <dd>{bloodBankInvestigationListEntity.bank ? bloodBankInvestigationListEntity.bank.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-investigation-list" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-investigation-list/${bloodBankInvestigationListEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankInvestigationListDetail;
